<template>
    <div class="page-header">
        <div class="page-header--inner" :class="{'page-header--inner-deleted' : deleted}">
            <div class="page-header--background" :style="`background-image: url(${randomImage})`"/>
            <div class="page-header--image img-frame" v-if="image">
                <img :src="image" :alt="title">
                <flex align="center" justify="center" class="page-header--image-edit" title="Bild ändern" @click="$emit('clickImage')" v-if="editImage">
                    <icon name="pencil"/>
                </flex>
            </div>
            <div class="page-header--details">
                <div class="page-header--title" v-if="title !== null">{{ title }}</div>
                <div class="page-header--subtitle" v-if="subtitle !== null">{{ subtitle }}</div>
                <slot/>
            </div>
        </div>
        
        <action-bar :actions="actions" :actionsMore="actionsMore" />

    </div>
</template>

<style lang="scss">
    .page-header {
        background-color: $white;
        box-shadow: $layout-shadow;
    }
    .page-header--inner {
        position: relative;
        display: flex;
        align-items: center;
        padding: $spacer-3;
        background-color: $dark-red;
        color: $white;
    }
    .page-header--inner .social-links > * {
        color: $white;
        background-color: transparent;
    }
    .page-header--background {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-size: cover;
        opacity: .35;
        z-index: 0;
    }
    .page-header--inner-deleted {
        background-color: $dark-60;
    }
    .page-header--inner-deleted .page-header--background {
        filter: grayscale(100%);
    }
    .page-header--image {
        position: relative;
        height: 120px;
        width: 120px;
        padding: 5px;
        margin-right: $spacer-3;
        border: 1px solid $dark-10;
        background-color: $white;
        box-shadow: $layout-shadow;
        z-index: 1;
    }
    .page-header--image-edit {
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        background-color: rgba($dark, .65);
        color: $white;
        font-size: 24px;
        opacity: 0;
        cursor: pointer;
        transition: opacity .2s;

        &:hover {
            opacity: 1;
        }
    }
    .page-header--details {
        z-index: 1;
    }
    .page-header--title {
        font-size: 20px;
        font-weight: bold;
        margin-top: $spacer-1;
    }
    .page-header--subtitle {
        font-size: $font-size-sm;
    }

    @include media-breakpoint-down("sm") {
        .page-header--inner {
            flex-direction: column;
        }
        .page-header--image {
            margin-right: 0;
            margin-bottom: $spacer-3;
        }
        .page-header--details {
            text-align: center;
        }
    }
</style>

<script>
    import random from 'lodash/random';

    export default {
        props: {
            image: {type: String, default: null},
            editImage: {type: Boolean, default: false},
            title: {type: String, default: null},
            subtitle: {type: String, default: null},
            actions: {type: Array, default: () => []},
            actionsMore: {type: Array, default: () => []},
            deleted: {type: Boolean, default: false},
        },

        data() {
            return {
                backgroundImages: [
                    '/img/header/wirsindstart_2019_1.jpg',
                    '/img/header/wirsindstart_2019_2.jpg',
                    '/img/header/wirsindstart_2019_3.jpg',
                    '/img/header/wirsindstart_2019_4.jpg',
                    '/img/header/wirsindstart_2019_5.jpg',
                    '/img/header/wirsindstart_2019_6.jpg',
                ],
            };
        },

        computed: {
            randomImage() {
                return this.backgroundImages[random(0, this.backgroundImages.length - 1)];
            },
        },
    };
</script>